import { createSelector } from 'reselect';
//import { CareersReduxType, CareersSelectorType } from '../types';

const careers = (state: { careersReducer: { careers: any } }) =>
    state.careersReducer.careers;

export const careersSelector = createSelector([careers], career => {
    let data: {
        title: string,
        description: string,
        jobOpeningsTitle: string,
        jobOpeningsList: [],
        bottomInfo: {},
    } = {
        title: "",
        description: "",
        jobOpeningsTitle: "",
        jobOpeningsList: [],
        bottomInfo: {},
    };
    if (career) {
        const { attributes } = career;
        data = {
            title: attributes.Title,
            description: attributes.Description,
            jobOpeningsTitle: attributes.JobOpeningsTitle,
            jobOpeningsList: attributes.JobOpenings,
            bottomInfo: attributes.BottomInfo,
        };
    }
    return data;
});
